import { render, staticRenderFns } from "./TimezoneChooser.vue?vue&type=template&id=65f83b47&"
import script from "./TimezoneChooser.vue?vue&type=script&lang=ts&"
export * from "./TimezoneChooser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports